module.exports = __webpack_public_path__ + "img/LogoDashboard-21.b055d4a0.svg";